var isShortTimeFormatWithoutLeadingZero = function (_a) {
    var length = _a.length;
    return length === 5 || length === 8;
};
var ɵ0 = isShortTimeFormatWithoutLeadingZero;
var time = function (_a) {
    var value = _a.value;
    return (isShortTimeFormatWithoutLeadingZero(value) ? value : "0" + value);
};
var ɵ1 = time;
export default (function (control) {
    var from = control.get('from');
    var to = control.get('to');
    if (!from || !to) {
        return null;
    }
    return time(from) < time(to) ? null : { invalidTime: true };
});
export { ɵ0, ɵ1 };
